import * as types from '../types'

const state = {
    thumb: 'recharge.jpg',
    content: [
        {
            id: 1,
            type: 2,
            content: '尝过这一味',
            sort: 0
        },
        {
            id: 2,
            type: 2,
            content: '解冻Tips：食用前一晚，将带包装的食材放在10-15℃的室温中解冻；或者冰箱冷藏室0-4℃冷藏解冻，这两种方式均可以保留住食材原本鲜嫩的肉质和营养成分。',
            sort: 1
        },
        {
            id: 3,
            type: 3,
            content: 'goods_imgs.png',
            sort: 2
        },
        {
            id: 4,
            type: 3,
            content: 'recharge.jpg',
            sort: 3
        },
        {
            id: 2,
            type: 2,
            content: '解冻Tips：食用前一晚，将带包装的食材放在10-15℃的室温中解冻；或者冰箱冷藏室0-4℃冷藏解冻，这两种方式均可以保留住食材原本鲜嫩的肉质和营养成分。',
            sort: 4
        }
    ],
    goodsList: [
        {
            id: 1,
            thumbnail: 'good.png',
            name: '不同妈妈生的五彩蛋',
            promote_action: '',
            shop_price: '50.00',
            promote_price: '49.99',
            count: 2,
            amount: '100.00'
        },
        {
            id: 2,
            thumbnail: 'good.png',
            name: '传统老素鸡',
            promote_action: '九折优惠',
            shop_price: '200',
            promote_price: '',
            count: 1,
            amount: '200.00'
        },
        {
            id: 13,
            thumbnail: 'good.png',
            name: '不同妈妈生的五彩蛋',
            promote_action: '',
            shop_price: '50.00',
            promote_price: '49.99',
            count: 2,
            amount: '100.00'
        },
        {
            id: 14,
            thumbnail: 'good.png',
            name: '传统老素鸡',
            promote_action: '九折优惠',
            shop_price: '200',
            promote_price: '',
            count: 1,
            amount: '200.00'
        }
    ]
}

const getters = {

}

const mutations = {

}

const actions = {

}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/recharge.js